"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var calculateOrderNumber_1 = require("./calculateOrderNumber");
var next_intl_1 = require("next-intl");
var useLevelPrizes_1 = require("./useLevelPrizes");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var LevelCard = function (_a) {
    var imgSrc = _a.imgSrc, levelTitle = _a.levelTitle, baseLevelTitle = _a.baseLevelTitle, pointsNeeded = _a.pointsNeeded, countLevelsInCard = _a.countLevelsInCard, currentIdx = _a.currentIdx, color = _a.color, level = _a.level, isCollected = _a.isCollected, userPoints = _a.userPoints, isShowPercents = _a.isShowPercents, percents = _a.percents, _b = _a.type, type = _b === void 0 ? 'grid' : _b, newbie = _a.newbie, firstLevelWithAward = _a.firstLevelWithAward;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var prizes = (0, useLevelPrizes_1.useLevelPrizes)(level);
    var orderNumber = (0, react_1.useMemo)(function () { return (0, calculateOrderNumber_1.calculateOrderNumber)(currentIdx, countLevelsInCard); }, [currentIdx, countLevelsInCard]);
    var points = (0, react_1.useMemo)(function () {
        if (isAuth && (userPoints || userPoints === 0))
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsContainer },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.currentPoints }, userPoints),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.points, " ").concat(type ? styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[type] : '') },
                    "/ ",
                    pointsNeeded,
                    " ",
                    isShowPercents && '(' + percents + '%)')));
        return react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.points) }, pointsNeeded);
    }, [type, isAuth, userPoints, isShowPercents, percents, pointsNeeded]);
    var textContent = (0, react_1.useMemo)(function () {
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.textContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.levelTitle }, levelTitle),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.descriptionTitle },
                t('prizes'),
                ":"),
            prizes.map(function (prize, idx) {
                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.prize, key: "prizes_vip_program_".concat(idx) }, prize));
            }),
            prizes.length === 0 && react_1.default.createElement("div", { className: styles_module_scss_1.default.prize }, "-"),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.descriptionTitle, style: { marginTop: '7px' } },
                t('pointsNeeded'),
                ":"),
            isCollected ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.collected }, t('collected'))) : (points)));
    }, [t, points, isCollected, levelTitle, prizes]);
    var newbieTextContent = (0, react_1.useMemo)(function () {
        if (Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet))
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.textContainer },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.levelTitle }, levelTitle),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.descriptionTitle },
                    t('untilFirstAward'),
                    ":"),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.newBiePointsDescriptions },
                    isAuth && (react_1.default.createElement("span", { className: styles_module_scss_1.default.newBieCurrentPoints }, userPoints)),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.newBieNextLevelPoints },
                        isAuth
                            ? " / ".concat((firstLevelWithAward === null || firstLevelWithAward === void 0 ? void 0 : firstLevelWithAward.fromPoints) || '')
                            : "".concat((firstLevelWithAward === null || firstLevelWithAward === void 0 ? void 0 : firstLevelWithAward.fromPoints) || ''),
                        ' '))));
        return react_1.default.createElement("div", { className: styles_module_scss_1.default.newbieLevelTitle }, baseLevelTitle);
    }, [
        firstLevelWithAward,
        userPoints,
        isAuth,
        baseLevelTitle,
        breakpoints,
        levelTitle,
        t,
    ]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.levelCardContainer, " ").concat(styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[color], " ").concat(orderNumber > countLevelsInCard / 2
            ? styles_module_scss_1.default.leftCircle
            : styles_module_scss_1.default.rightCircle, " ").concat(orderNumber > countLevelsInCard / 2 ? styles_module_scss_1.default.leftLine : styles_module_scss_1.default.rightLine, " ").concat(isCollected ? styles_module_scss_1.default.collected : ''), style: {
            order: orderNumber,
            marginTop: orderNumber === 1 ? '100px' : 'initial',
        } },
        react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: imgSrc, alt: "level" }),
        newbie ? newbieTextContent : textContent));
};
exports.default = LevelCard;
